import { render, staticRenderFns } from "./task_title.vue?vue&type=template&id=3aeb397b&scoped=true"
import script from "./task_title.vue?vue&type=script&lang=js"
export * from "./task_title.vue?vue&type=script&lang=js"
import style0 from "./task_title.vue?vue&type=style&index=0&id=3aeb397b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aeb397b",
  null
  
)

export default component.exports